import { useState } from "react";
import { INIT_FILTER_FIELDS } from "../constants";

const useFilters = ({
    isCoordinator,
    setCurrentPage,
    loadingRequest
}) => {
    const [filterFields, setFilterFields] = useState({ ...INIT_FILTER_FIELDS });
    const changeFilterField = async (field, value) => {
        setFilterFields(prev => ({
            ...prev,
            [field] : value
        }));
    }
    const changeAdviserCodeFilterField = (value, setTriggerRequest) => {
        if (filterFields.adviserCode && !value) 
            setCurrentPage(1);
        changeFilterField("adviserCode", value);
        loadingRequest.show();
        setTriggerRequest(true);
    }
    const clearFilterFields = (clearSchedules, setTriggerRequest) => {
        setFilterFields({ 
            ...INIT_FILTER_FIELDS, 
            adviserCode: !isCoordinator 
                ? filterFields.adviserCode 
                : INIT_FILTER_FIELDS.adviserCode 
        });
        setCurrentPage(1);
        clearSchedules();
        if (!filterFields.student.field) 
            setTriggerRequest(true);
    }
    const isClearedFilterFields = () => {
        const { adviserCode, date, student } = filterFields;
        return (
            (!isCoordinator || !adviserCode) &&
            date === -1 && 
            !student.field
        );
    }
    return {
        value: filterFields,
        set: setFilterFields,
        change: changeFilterField,
        changeAdviserCode: changeAdviserCodeFilterField,
        clear: clearFilterFields,
        isCleared: isClearedFilterFields
    };
}

export default useFilters;